import React from 'react';
import cl from './Spinner.module.css';

/**
 * Спиннер в стиле админ-панели: строгий, минималистичный.
 * Два кольца (внешнее против часовой, внутреннее по часовой) + текст.
 * Цвета — нейтральный синий (#3b82f6) на тёмно-сером тексте, без emoji.
 *
 * Props:
 *   size:  'small' | 'medium' | 'large'  — размер кольца (48 / 72 / 96 px)
 *   text:  string  — подпись под спиннером, default 'Загрузка'
 *   showText: bool — показывать ли текст вообще
 *   center: bool   — если true, центрировать в родителе (flex)
 *   fullPage: bool — если true, занять всю высоту окна
 */
const Spinner = ({
    size = 'medium',
    text = 'Загрузка',
    showText = true,
    center = false,
    fullPage = false,
}) => {
    const wrapperClasses = [
        cl.wrapper,
        center && cl.center,
        fullPage && cl.fullPage,
    ].filter(Boolean).join(' ');

    return (
        <div className={wrapperClasses}>
            <div className={`${cl.spinner} ${cl[size]}`}>
                <div className={cl.ringOuter}/>
                <div className={cl.ringInner}/>
                <div className={cl.dot}/>
            </div>
            {showText && (
                <div className={cl.label}>
                    {text}
                    <span className={cl.dots}>
                        <span/><span/><span/>
                    </span>
                </div>
            )}
        </div>
    );
};

export default Spinner;
